<template>
  <product-loading v-if="loading" />
  <v-container v-else-if="product" class="pt-10">
    <h4 class="text-uppercase">Menu Item</h4>
    <h1 class="text-h5 text-lg-h4 mb-5">{{ product.title }}</h1>
    <div class="d-flex flex-column-reverse flex-md-row">
      <div class="d-flex d-md-block justify-center mr-md-3">
        <v-card
          v-for="(image, index) in product.images"
          class="d-inline-block d-md-block mb-md-3 ma-1 ma-md-0 overflow-hidden"
          flat
          rounded
          link
          @click="selectedImage = image"
          :key="index"
        >
          <v-img :src="image.src" height="48" maxWidth="48" />
        </v-card>
      </div>
      <div class="mb-1 min-w-0 mx-md-auto">
        <div v-if="!selectedImage" class="grey lighten-2" style="width: 100%">
          <v-icon
            class="d-flex"
            color="grey lighten-1"
            size="150"
            style="height: 300px"
          >mdi-image-outline</v-icon>
        </div>
        <v-img
          v-else-if="$vuetify.breakpoint.mobile"
          :src="selectedImage.src"
          height="300"
          width="100%"
          contain
        />
        <image-magnifier
          v-else
          :src="selectedImage.src"
          :zoomSrc="selectedImage.src"
          zoomClass="v-sheet theme--light elevation-4 rounded"
          zoomWidth="372"
          zoomHeight="603"
          maskHeight="183.73"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="12" class="mx-auto">
        <v-card class="pa-6">
          <div v-if="product.body_html" v-dompurify-html="product.body_html" class="py-2 body-1 font-weight-medium"></div>
          <div v-else class="font-italic">No description.</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-alert type="error">Can not find product.</v-alert>
  </v-container>
</template>
<script>
import productLoading from '../utilities/productLoading.vue';
import { mapState } from 'vuex';
export default {
  name: 'MenuDetails',
  components: { productLoading },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data: function () {
    return {
      selectedImage: null,
      loading: false
    };
  },
  computed: {
    ...mapState('menu', {
      product: state => state.details
    })
  },
  created: function () {
    this.loading = true;
    this.$store.dispatch('menu/getDetails', this.id)
      .then(product => {
        this.selectedImage = product?.images[0];
        this.loading = false;
      });
  }
};
</script>
